import React from 'react';
import ProductsView from './View';

const ProductsEdit = (props) => {
  return <ProductsView props={props} />;
};

export default ProductsEdit;
